import { Cartao, CabecalhoDePagina } from '../componentes/Superficie.tsx';
import { RoteiroDeCadencia } from '../componentes/RoteiroDeCadencia.tsx';

/**
 * Configuração do roteiro de cadência.
 *
 * O Sales mostra o roteiro vigente e dispara cadências; aqui se edita o modelo.
 */
export function PaginaCadencias(): React.JSX.Element {
  return (
    <section>
      <CabecalhoDePagina
        area="Administração"
        titulo="Cadências"
        descricao="O roteiro de tentativas de contato aplicado às Oportunidades. Nesta fase ele organiza e agenda; os envios reais entram em fases futuras."
      />
      <Cartao>
        <RoteiroDeCadencia />
      </Cartao>
    </section>
  );
}
